function isLocalDev(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname;

  return hostname.endsWith('.local.sportsfi.tech') || hostname === 'localhost';
}

function getSecurityAttributes(): string {
  return isLocalDev() ? '' : '; Secure; SameSite=None';
}

export function setCookie(name: string, value: string, domain?: string, maxAge?: number): void {
  if (typeof document === 'undefined') {
    return;
  }

  let cookie = `${name}=${value}; Path=/`;

  if (domain) {
    cookie += `; Domain=${domain}`;
  }

  if (maxAge != null) {
    cookie += `; Max-Age=${maxAge}`;
  }

  cookie += getSecurityAttributes();
  document.cookie = cookie;
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((c) => c.startsWith(`${name}=`));

  return cookie?.split('=')[1] ?? null;
}

export function deleteCookie(name: string, domain?: string): void {
  setCookie(name, '', domain, 0);
}
